module.exports = __webpack_public_path__ + "img/icon_main_1.c32ddc75.svg";